import React from 'react'
import * as S from './style.Style'

const Description = ({isMaisPremiavel}) => (
    <>
        <S.DefaultSpan>
            Durante todo o seu contrato, você concorre a sorteios
            mensais de até <S.OrangeSpan>{isMaisPremiavel ? "R$ 350 mil" : "R$ 750 mil" }</S.OrangeSpan> que podem ser utilizados para quitar ou amortizar o seu financiamento.
            <br />
            <br />
            Fique tranquilo! Se você for sorteado, entraremos em contato.
        </S.DefaultSpan>
    </>
)

export default Description